module.exports = __webpack_public_path__ + "ba79dd96f9bcd5fc030c4b043eb2d522.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/styles/medium/public/games/dow_image_1.jpg
// module id = 498
// module chunks = 0